import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource-variable/archivo';
import '@fontsource-variable/jetbrains-mono';
import './index.css';
import App from './App.tsx';
import { initPwaInstall } from './lib/pwaInstall';

// Capter `beforeinstallprompt` avant le rendu React (l'événement peut arriver tôt).
initPwaInstall();

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <App />
    </StrictMode>,
);

// Sentry chargé hors du chemin critique (après le premier rendu) pour alléger le bundle initial.
// Uniquement si un DSN est configuré (prod) — en dev sans DSN, rien n'est chargé.
if (import.meta.env.VITE_SENTRY_DSN) {
    import('./sentry').then((m) => m.initSentry());
}
